import { render, staticRenderFns } from "./MYP401M01.vue?vue&type=template&id=6c15d0fe&"
import script from "./MYP401M01.vue?vue&type=script&lang=js&"
export * from "./MYP401M01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports